import { useAtomValue } from "jotai";
import { useLocation } from "react-router-dom";

import Button from "components/Button";
import { DJPointOfImpactList } from "components/DJVehicleDamageLocation/DJPointOfImpactList";
import { DJVehicleImpact } from "components/DJVehicleDamageLocation/DJVehicleImpact";
import Flex from "components/Flex";
import PageLayout from "components/PageLayout";
import Text from "components/Text";

import { DigitalJourneyRoute } from "app/DigitalJourneyAppFlow/constants";
import {
  isValidOtherPOIAtom,
  isValidPOIAtom,
  otherVehiclePointsOfImpactAtom,
  pointsOfImpactPhAtom,
} from "atoms/pointsOfImpactDigitalJourney";
import { sessionIdAtom } from "atoms/sessionId";
import { vehicleTypeAtom } from "atoms/vehicleType";
import { useClientTranslation } from "hooks/useClientTranslation";
import { useDigitalJourneyPageRouting } from "hooks/useDigitalJourneyPageRouting";
import { useEventTracking } from "hooks/useEventTracking";
import { VehicleType } from "types/DigitalJourneySession";

export const DJDamageLocationPHPage = () => {
  const { t } = useClientTranslation();
  const { trackEvent } = useEventTracking();
  const { onNext, continueCTA } = useDigitalJourneyPageRouting();
  const { pathname } = useLocation();
  const sessionId = useAtomValue(sessionIdAtom);
  const phVehicleSelectedPoints = useAtomValue(pointsOfImpactPhAtom);
  const otherVehicleSelectedPoints = useAtomValue(otherVehiclePointsOfImpactAtom);
  const isValidPOI = useAtomValue(isValidPOIAtom);
  const isValidOtherPOI = useAtomValue(isValidOtherPOIAtom);
  const vehicleType = useAtomValue(vehicleTypeAtom);

  const route = pathname.replace(sessionId, ":session");
  const isValid =
    route === DigitalJourneyRoute.DamageLocationPH
      ? isValidPOI
      : DigitalJourneyRoute.DamageLocationOther
      ? isValidOtherPOI
      : false;
  const selectedPoints =
    route === DigitalJourneyRoute.DamageLocationPH
      ? phVehicleSelectedPoints
      : DigitalJourneyRoute.DamageLocationOther
      ? otherVehicleSelectedPoints
      : [];

  const onContinue = () => {
    trackEvent({
      name: "Digital Journey Policy Holder Damage Location - continue",
      properties: { damageArea: selectedPoints.join(", ") },
    });
    onNext();
  };

  return (
    <PageLayout contentSpacing="space-between">
      <Flex px={24} py={24} gap={16} flex={1} mb={16}>
        <Text as="h1" sizeVariant="xl" weight={600}>
          Dove è avvenuto l'impatto?
        </Text>
        <DJPointOfImpactList />
        <DJVehicleImpact isCar={vehicleType === VehicleType.CAR} />
      </Flex>
      <Flex px={24} py={24} gap={16}>
        <Button disabled={!isValid} onClick={onContinue}>
          {continueCTA}
        </Button>
      </Flex>
    </PageLayout>
  );
};
